import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { WeatherDemoService } from '../../design/demo-services/weater-demo.service';


@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: WeatherDemoService) { }

  getWeatherData(date: string, locationCode: string, recordType: number): Observable<any> {
    
    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/getWeather?dateTime=${date}&locationCode=${locationCode}&recordType=${recordType}`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get(date) : this.http.get(url))
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: true, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        const ret = d.isError === true ? d : {

          DayWeatherText: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Day.ShortPhrase,
          DayIcon: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.Icon,
          DayIconPhrase: d.DailyForecasts.length === 0 ? "" :d.DailyForecasts[0].Day.IconPhrase,
          DayLongPhrase: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Day.LongPhrase,
          DayPrecipitationProbability: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.PrecipitationProbability + "%",
          DayTotalPrecipitation: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.TotalLiquid.Value + " " + d.DailyForecasts[0].Day.TotalLiquid.Unit,
          DayTotalRain: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.Rain.Value + " " + d.DailyForecasts[0].Day.Rain.Unit,
          DayTotalSnow: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.Snow.Value + " " + d.DailyForecasts[0].Day.Snow.Unit,
          DayTotalIce: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.Ice.Value + " " + d.DailyForecasts[0].Day.Ice.Unit,
          DayCloudCover: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.CloudCover + "%",
          DayWind: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Day.Wind.Speed.Value + " " + d.DailyForecasts[0].Day.Wind.Speed.Unit,
          DayWindGust: d.DailyForecasts.length === 0 ? 0 :d.DailyForecasts[0].Day.WindGust.Speed.Value + " " + d.DailyForecasts[0].Day.WindGust.Speed.Unit,

          NightWeatherText: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Night.ShortPhrase,
          NightIcon: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.Icon,
          NightIconPhrase: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Night.IconPhrase,
          NightLongPhrase: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Night.LongPhrase,
          NightPrecipitationProbability: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.PrecipitationProbability + "%",
          NightTotalPrecipitation: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.TotalLiquid.Value + " " + d.DailyForecasts[0].Night.TotalLiquid.Unit,
          NightTotalRain: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.Rain.Value + " " + d.DailyForecasts[0].Night.Rain.Unit,
          NightTotalSnow: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.Snow.Value + " " + d.DailyForecasts[0].Night.Snow.Unit,
          NightTotalIce: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.Ice.Value + " " + d.DailyForecasts[0].Night.Ice.Unit,
          NightCloudCover: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.CloudCover + "%",
          NightWind: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.Wind.Speed.Value + " " + d.DailyForecasts[0].Night.Wind.Speed.Unit,
          NightWindGust: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Night.WindGust.Speed.Value + " " + d.DailyForecasts[0].Night.WindGust.Speed.Unit,

          TemperatureMaxValue: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Temperature.Maximum.Value,
          TemperatureMaxUnit: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Temperature.Maximum.Unit,
          TemperatureMinValue: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Temperature.Minimum.Value,
          TemperatureMinUnit: d.DailyForecasts.length === 0 ? 0 : d.DailyForecasts[0].Temperature.Minimum.Unit,
          
          Sources: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Sources[0],
          Link: d.DailyForecasts.length === 0 ? "" : d.DailyForecasts[0].Link,

          LastUpdated: d.LastUpdated,

          isNotFound: d.DailyForecasts.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}

